import middlePrimarySecondaryReport from "./middlePrimarySecondaryReport.vue";
export default middlePrimarySecondaryReport;
